import React from 'react'
import { Image } from 'react-native'

import { Stack } from '@zet/design-system/layout'
import { B2, H5 } from '@zet/design-system/typography'

import LinkBrokenIcon from '../../assets/images/statusScreens/linkBroken.svg'
import { brandsI18n } from '../../localization'

export const LinkBroken = () => {
  return (
    <Stack className="flex-1 items-center justify-center bg-white">
      <Image
        source={LinkBrokenIcon}
        resizeMode="contain"
        className="mb-4 h-44 w-60 rounded-lg"
      />
      <H5 className="mb-2">{brandsI18n.t('common.linkBroken')}</H5>
      <B2>{brandsI18n.t('common.contactAgentLinkBroken')}</B2>
    </Stack>
  )
}
